import { render, staticRenderFns } from "./ViewForgotPassword.vue?vue&type=template&id=685d6a74&"
import script from "./ViewForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ViewForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports